const productionApiEndpoint = 'https://api.zaplify.com';
const devFallbackApiEndpoint = 'http://localhost:8000';
const stagingFallbackApiEndpoint = 'https://staging.api.zaplify.com';

export const socketEndpoint =
    (import.meta.env.NODE_ENV === 'production' && (import.meta.env.VITE_SOCKET_ENDPOINT || productionApiEndpoint)) ||
    (import.meta.env.NODE_ENV === 'staging' && (import.meta.env.VITE_SOCKET_ENDPOINT || stagingFallbackApiEndpoint)) ||
    import.meta.env.VITE_SOCKET_ENDPOINT ||
    devFallbackApiEndpoint;
